export default {
	routes: []
}
